const SIZES_ENUMS = { SM: "sm", MD: "md" };
const VARIANTS_ENUMS = {
  PRIMARY: "primary",
  ERROR: "error",
  WARNING: "warning",
  SUCCESS: "success",
  INFORMATION: "information",
  HINT: "hint",
  HIGHLIGHT: "highlight",
  NEUTRAL: "neutral",
  OUTLINED: "outlined"
};
const EMPHASIS_ENUMS = { SUBTLE: "subtle", STRONG: "strong" };
export {
  EMPHASIS_ENUMS,
  SIZES_ENUMS,
  VARIANTS_ENUMS
};
//# sourceMappingURL=constants.mjs.map
